import { defineStore } from 'pinia'
import { computed, reactive, ref } from 'vue'

import liff from '@line/liff'
import router from '@/router/index'

export const useLiffStore = defineStore('liff', () => {
  // const isDev = process.env.VUE_APP_MODE === "dev";

  const isLiffInit = ref(false)

  const liffData = reactive({
    LineIdToken: null,
  })

  async function liffinit() {
    if (isLiffInit.value) return true

    const liffId = process.env.VUE_APP_LINE_LIFF_ID

    try {
      await liff.init({
        liffId: liffId,
      })
    } catch (error) {
      console.log('liff init error', error)
    }

    isLiffInit.value = true

    return true
  }

  async function liffLogin() {
    const isLogin = liff.isLoggedIn()

    if (!isLogin) {
      liff.login({ redirectUri: window.location.href })
    } else {
      getLiffProfile()

      const isFrirend = await liff.getFriendship()
      if (!isFrirend.friendFlag) {
        liffAddFriend()
      }
      liffData.LineIdToken = liff.getIDToken()
    }

    return true
  }

  function liffLogout() {
    if (liff.isLoggedIn()) {
      liff.logout()
    }
  }

  async function getLiffProfile() {
    try {
      const decodeIdToken = liff.getDecodedIDToken()
      const currTime = Math.floor(Date.now() / 1000)
      // console.log('decodeIdToken', decodeIdToken)
      // 過期的話重新登入
      if (decodeIdToken && decodeIdToken?.exp < currTime) {
        liffLogout()
        liffLogin()
      }
    } catch (error) {
      console.log(error)
    }

    return true
  }

  const oaAccountHref = `https://lin.ee/${process.env.VUE_APP_LINE_OA_ID}`

  function liffAddFriend() {
    window.location.href = oaAccountHref
  }

  const liffShareData = ref({
    isReady: false,
    ShareLink: computed(
      () =>
        process.env.VUE_APP_LINE_LIFF_URL +
        'Event/' +
        router.currentRoute.value.params?.id
    ),
    ShareTitle: '',
    ShareDescription: '',
    LineShareImageUrl: '',
  })

  function liffShareDataSet(data) {
    liffShareData.value.isReady = true
    liffShareData.value.ShareTitle = data.ShareTitle
    liffShareData.value.ShareDescription = data.ShareDescription
    liffShareData.value.LineShareImageUrl = data.LineShareImageUrl
  }

  async function liffShare() {
    if (!liff.isLoggedIn()) {
      liffLogin()
    }
    if (liff.isApiAvailable('shareTargetPicker')) {
      const shareRes = await liff.shareTargetPicker([
        {
          type: 'flex',
          altText: liffShareData.value.ShareTitle,
          contents: {
            type: 'bubble',
            hero: {
              type: 'image',
              url: liffShareData.value.LineShareImageUrl,
              size: 'full',
              aspectRatio: '20:13',
              aspectMode: 'cover',
              action: {
                type: 'uri',
                uri: liffShareData.value.ShareLink,
              },
            },
            body: {
              type: 'box',
              layout: 'vertical',
              contents: [
                {
                  type: 'text',
                  text: liffShareData.value.ShareTitle,
                  weight: 'bold',
                  size: 'xl',
                  wrap: true,
                },
                {
                  type: 'box',
                  layout: 'vertical',
                  margin: 'lg',
                  spacing: 'sm',
                  contents: [
                    {
                      type: 'box',
                      layout: 'baseline',
                      spacing: 'sm',
                      contents: [
                        {
                          type: 'text',
                          text: liffShareData.value.ShareDescription,
                          wrap: true,
                          color: '#666666',
                          size: 'md',
                          flex: 5,
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            footer: {
              type: 'box',
              layout: 'vertical',
              spacing: 'sm',
              contents: [
                {
                  type: 'button',
                  style: 'link',
                  height: 'sm',
                  action: {
                    type: 'uri',
                    label: '加入官方帳號',
                    uri: oaAccountHref,
                  },
                },
                {
                  type: 'button',
                  style: 'link',
                  height: 'sm',
                  action: {
                    type: 'uri',
                    label: '前往報名活動',
                    uri: liffShareData.value.ShareLink,
                  },
                },
                {
                  type: 'box',
                  layout: 'vertical',
                  contents: [],
                  margin: 'sm',
                },
              ],
              flex: 0,
            },
          },
        },
      ])
      if (shareRes?.status === 'success') {
        return true
      }
    }
    return false
  }

  return {
    liff,
    isLiffInit,
    liffData,
    liffinit,
    liffLogin,
    liffLogout,
    liffAddFriend,
    liffShareData,
    liffShareDataSet,
    liffShare,
  }
})
